var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "@application/store/useStore";
import { deleteAccessPoint, } from "@reducers/access-points/thunk/access-point-thunk";
export const useDashboardActions = (refetch) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const handleDeleteAccessPoint = useCallback((accessPointUid) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield dispatch(deleteAccessPoint(accessPointUid)).unwrap();
            refetch === null || refetch === void 0 ? void 0 : refetch();
            return true;
        }
        catch (err) {
            console.error("Failed to delete access point:", err);
            throw err;
        }
    }), [dispatch, refetch]);
    const handleViewNodes = useCallback((deviceId) => {
        navigate(`/dashboard/${deviceId}`);
    }, [navigate]);
    const handleSettings = useCallback((deviceId) => {
        navigate(`/dashboard/${deviceId}/edit`);
    }, [navigate]);
    return {
        handleDeleteAccessPoint,
        handleViewNodes,
        handleSettings,
    };
};
